import React from 'react';
import { TextField } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from 'app/cluster-styles/useStyles';
import SectionCard from './SectionCard';

export default function DescriptionSection({ form, setField }) {
    const classes = useStyles();

    return (
        <SectionCard icon="description" title="Description">
            <TextField
                className={clsx(classes.input, 'my-16 w-full')}
                id="cluster-description"
                name="description"
                label="Description"
                type="textarea"
                variant="outlined"
                value={form.description || ''}
                onChange={(e) => setField('description', e.target.value)}
                fullWidth
                multiline
                minRows={3}
                placeholder="Enter a description for this cluster..."
            />
        </SectionCard>
    );
}
